<template>
  <div>
    <div class="operation"></div>
    <el-table :data="data" v-loading="loading">
      <el-table-column :label="$ct('unitName')" prop="name"></el-table-column>
      <el-table-column :label="$ct('proposer')" prop="applicant_name"></el-table-column>
      <el-table-column :label="$ct('applicationTime')" prop="created_at">
        <template slot-scope="s">
          <span>{{s.row.created_at ? formatDate(s.row.created_at) : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('teacher')" prop="teacher_count"></el-table-column>
      <el-table-column :label="$ct('registered')" prop="register_student_count"></el-table-column>
      <el-table-column :label="$ct('activatedStudent')" prop="activat_student_count"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;padding-top:20px"
      background=""
      layout="prev, pager, next,total, jumper"
      :total="total"
      :current-page.sync="page"
      :page-size="15"
      @current-change="pageChange"
      v-if="total > 0 "
    ></el-pagination>
  </div>
</template>

<script>
import { formatDate } from '@/utils/utils'
export default {
  inject: ['iPath'],
  props: {
    data: Array,
    loading: Boolean
  },
  data() {
    return {
    }
  },
  computed: {
    page: {
      get() {
        return this.$store.state.unitManage.page
      },
      set(page) {
        this.$store.commit('setState', {
          module: 'unitManage',
          key: 'page',
          value: page
        })
        this.$emit('getData')
      }
    },
    total() {
      return this.$store.state.unitManage.total
    },
    id() {
      return this.$store.state.user.id
    },
    role_id() {
      return this.$store.state.user.role_id
    }
  },
  methods: {
    pageChange(page) {
      this.page = page
    },
    checkClass(s) {
      this.$store.commit('setState', {
        module: 'classManage',
        key: 'teacher_id',
        value: s.row.id
      })
      const teacher_id = s.row.id
      this.$store.commit('classManageInitTeacher', teacher_id)
      this.$router.push(this.iPath('/classManage'))
    },
    formatDate(date) {
      return formatDate(date)
    }
  }
}
</script>
